import React from 'react';
import { ProductDetailed } from "../components/Product";
import { useSelector } from "react-redux";
import { componentHeight } from '../features/general/generalSlice';
import useAuth from '../hooks/useAuth';
import Loading from '../components/Loading';
import NoData from "../assets/images/NoData.png";
import useMyProduct from '../hooks/useMyProduct';
import useCart from '../hooks/useCart';

const Store = ({ useFor }) => {
  const { componentHeight } = useSelector((state) => state?.general);
  
  // Use custom hooks
  const { myProducts: myItems, isLoading: isLoadingMyProducts } = useMyProduct();
  const { cartItems, isLoading: isLoadingCart } = useCart();

  // Show loading state while data is being fetched
  if ((useFor === "my-store" && isLoadingMyProducts) || (useFor === "cart" && isLoadingCart)) {
    return <Loading />;
  }
  
  let content;

  if(useFor === "my-store"){
    if (myItems?.length === 0) {
      content = (
        <div className='w-full flex flex-col justify-center items-center flex-grow' style={{ minHeight: `${componentHeight}vh` }}>
          <img src={NoData} alt='pic' className='w-[60%]' />
          <p className='text-[1.4rem] text-slate-400 italic'>No Product Posted</p>
        </div>
      );
    } else {
      const tableContent = myItems?.length
        ? myItems.map((product) => (
            <ProductDetailed key={product?._id} product={product} page={useFor} />
          ))
        : null;
  
      content = (
          <div 
            className="bg-custom-content-bg w-full p-2 flex flex-col justify-start items-start"
            style={{ minHeight: `${componentHeight}vh` }}
          >
            {tableContent} 
          </div>
      );
    }
  } else {
    if (cartItems?.length === 0) {
      content = (
        <div className='w-full flex flex-col justify-center items-center flex-grow' style={{ minHeight: `${componentHeight}vh` }}>
          <img src={NoData} alt='pic' className='w-[60%]' />
          <p className='text-[1.4rem] text-slate-400 italic'>No Product In Cart</p>
        </div>
      );
    } else {
      const tableContent = cartItems?.length
        ? cartItems.map((product) => (
            <ProductDetailed key={product?._id} product={product} page={useFor} />
          ))
        : null;
      
      content = (
          <div 
            className="bg-custom-content-bg w-full flex flex-col justify-start items-center"
            style={{ minHeight: `${componentHeight}vh` }}
          >
            {tableContent} 
          </div>
      );
    }
  }

  return content;
}

export default Store;